var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71809 9.70971C1.64866 9.89677 1.64866 10.1025 1.71809 10.2896C2.39438 11.9294 3.54233 13.3315 5.01643 14.3181C6.49052 15.3047 8.22436 15.8313 9.99815 15.8313C11.7719 15.8313 13.5058 15.3047 14.9799 14.3181C16.454 13.3315 17.6019 11.9294 18.2782 10.2896C18.3476 10.1025 18.3476 9.89677 18.2782 9.70971C17.6019 8.06991 16.454 6.66783 14.9799 5.68124C13.5058 4.69465 11.7719 4.16797 9.99815 4.16797C8.22436 4.16797 6.49052 4.69465 5.01643 5.68124C3.54233 6.66783 2.39438 8.06991 1.71809 9.70971Z",
    stroke: "white",
    strokeWidth: 1.99836,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99854 12.499C11.379 12.499 12.498 11.38 12.498 9.99951C12.498 8.61907 11.379 7.5 9.99854 7.5C8.61809 7.5 7.49902 8.61907 7.49902 9.99951C7.49902 11.38 8.61809 12.499 9.99854 12.499Z",
    stroke: "white",
    strokeWidth: 1.99836,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEye);
export default __webpack_public_path__ + "static/media/white_eye.cb619c3cd48a8a940c5bdbfae20a925e.svg";
export { ForwardRef as ReactComponent };